import type { ISVG } from './index';

/**
 * A ballot line: the tick square, then the name rule and the shorter running-mate rule beneath —
 * the Seat view's ballot strip, reduced to a sidebar glyph. Stacked twice, because a registry is
 * many lines. Sidebar nav icon.
 */
export const CandidateRecordsSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
		aria-hidden='true'
	>
		<rect
			x='3'
			y='4'
			width='5'
			height='5'
			rx='0.75'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
		<path
			d='M11 5.25h10M11 8h6'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
		<rect
			x='3'
			y='14'
			width='5'
			height='5'
			rx='0.75'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
		<path
			d='M4.4 16.6l1 1 1.9-2.1'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M11 15.25h10M11 18h6'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
	</svg>
);
